////////LIBRARY/////////
import React, { useEffect } from 'react'
import styled from 'styled-components'
import _, { isEqual } from 'lodash'
import moment from 'moment'
import { bindActionCreators } from 'redux'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
///////COMPONENTS///////
import Button from '../../../../components/Ui/Buttons'
import Modals from '../../../../components/Modals'
import theme from '../../../../theme/theme'
import { TextModal } from '../../../../theme/GlobalCss'
import StringFormatter from '../../../../helpers/StringFormatter'
import { articleLifeManagerActionCreators } from '../../../../store/actions'
/////////ASSETS/////////
import Validation from '../../../../assets/icones/global/check.svg'
import Cancel from '../../../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const ModalDeleteStopWithRestockActionWrapper = styled.div``
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	width: 100%;
	justify-content: space-between;
`
const TextTopWrapper = styled.div`
	margin: 15px 0;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 0;
`
const TextModalCustom = styled.div`
	padding: 0;
`
const TextModalWrapperBottom = styled(TextModalWrapper)`
	margin-bottom: 15px;
	display: flex;
	justify-content: flex-start;
`
const TextModalRed = styled(TextModal)`
	color: ${(props) => props.theme.colors.error};
	font-weight: 900;
`
/////////STYLED/////////
// [88]_g: DELETE DATE STOP RESTOCK

const ModalDeleteStopWithRestockAction = (props) => {
	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleDeleteStopWithRestockActionn = () => {
		actionsArticleLifeManager.postDeleteStopWithRestockAction(props.deleteStopWithRestockAction.item.header.id)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.deleteStopWithRestockAction.close()
	}, [articleLifeManager?.isUpdate])

	const article = `<span style="color: ${theme.colors.primary}" > [${props?.deleteStopWithRestockAction?.item?.header?.itemRefLabel}] </span>`
	const date = `<span style="color: ${theme.colors.primary}" > ${moment(props?.deleteStopWithRestockAction?.current?.dateToModify).format(
		'DD/MM/YYYY'
	)} </span>`
	let text = StringFormatter.ResponseMessageParser(
		_.replace(translations['modal__itemRef__timeline_action_restock_startDate_delete_message_firstPart'], '\\n', '<br>'),
		[article, date]
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ModalDeleteStopWithRestockActionWrapper>
			<Modals
				showModal={props?.deleteStopWithRestockAction?.show}
				closeModalHandler={props?.deleteStopWithRestockAction?.close}
				level="error"
				icon={true}
				title={translations['modal__itemRef__timeline_action_restock_startDate_delete_title']}
				width={555}
			>
				{translations && !isEqual(props?.deleteStopWithRestockAction?.item?.header, {}) && (
					<TextTopWrapper>
						<TextModalWrapper>{<TextModalCustom dangerouslySetInnerHTML={{ __html: text }} />}</TextModalWrapper>
					</TextTopWrapper>
				)}
				<TextModalWrapperBottom>
					<TextModalRed>{translations['modal__itemRef__timeline_action_restock_startDate_delete_message_secondPart']}</TextModalRed>
				</TextModalWrapperBottom>

				<ButtonWrapper>
					<Button
						actionHandler={props?.deleteStopWithRestockAction?.close}
						text={translations['common__text__cancel']}
						bgColor={theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleDeleteStopWithRestockActionn()}
						text={translations['modal__itemRef__timeline_action_restock_startDate_delete_buttons_validate']}
						bgColor={theme.colors.validation}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
		</ModalDeleteStopWithRestockActionWrapper>
	)
}

ModalDeleteStopWithRestockAction.propTypes = {}

ModalDeleteStopWithRestockAction.defaultPropTypes = {}

export default ModalDeleteStopWithRestockAction
